/* Blank PDP gallery: many supplier photos are shot on a light grey backdrop, which showed as a grey
   rectangle inside the white rounded gallery box. Each photo's backdrop colour is sampled from its
   two top corners (a 48px copy through the CDN, which serves CORS) and painted behind the photo, so
   it reads as one clean card. White-backdrop photos stay white. Skipped when the corners disagree
   or are dark, i.e. when there is no plain light backdrop to match. Loaded by
   snippets/blanks-pdp-top.liquid. (Justin 2026-09-23)

   The colour goes in a stylesheet rule keyed to the photo's FILE NAME, not onto an element. The
   theme clears the photo's inline style once it loads, rewrites the slide's and figure's inline
   style for their aspect-ratio padding, and swaps slides and photos for fresh copies after load,
   so a colour set on any particular element was lost every time. A rule matching
   img[src*="/<file>"] (and the figure holding it, through :has) follows whichever copy of that
   photo is on the page. */
(function () {
  var done = {}, rules = {};
  function sheet() {
    var el = document.getElementById('blanks-gallery-bg');
    if (!el) { el = document.createElement('style'); el.id = 'blanks-gallery-bg'; document.head.appendChild(el); }
    return el;
  }
  function fileOf(src) {
    var m = String(src || '').split('?')[0].match(/\/([^\/]+\.(?:jpe?g|png|webp|gif))$/i);
    return m ? m[1] : '';
  }
  function small(src) {
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=48');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=48';
  }
  function sample(src, file) {
    done[file] = true;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var c = document.createElement('canvas');
        var w = c.width = probe.naturalWidth, h = c.height = probe.naturalHeight;
        if (!w || !h) return;
        var x = c.getContext('2d');
        x.drawImage(probe, 0, 0);
        /* backdrop from four points: both top corners and both side edges a third of the way
           down, where the seam with the fill actually is; all four must agree */
        var pts = [[1, 1], [w - 2, 1], [2, Math.round(h * 0.33)], [w - 3, Math.round(h * 0.33)]];
        var px = pts.map(function (p) { return x.getImageData(p[0], p[1], 1, 1).data; });
        var lo = [255, 255, 255], hi = [0, 0, 0], sum = [0, 0, 0];
        px.forEach(function (d) { for (var k = 0; k < 3; k++) { lo[k] = Math.min(lo[k], d[k]); hi[k] = Math.max(hi[k], d[k]); sum[k] += d[k]; } });
        var spread = (hi[0] - lo[0]) + (hi[1] - lo[1]) + (hi[2] - lo[2]);
        if (spread > 30 || Math.min(lo[0], lo[1], lo[2]) < 200) return;
        var col = 'rgb(' + Math.round(sum[0] / 4) + ',' + Math.round(sum[1] / 4) + ',' + Math.round(sum[2] / 4) + ')';
        var f = file.replace(/"/g, ''), ratio = (w / h).toFixed(4);
        /* the fill goes on the figure behind the photo, and the photo's outer 8px are feathered
           into it (only on sides with letterbox space: the feather is min(8px, gap)) so the thin
           light border these supplier photos carry, and any tone step, fade out. Container query
           units on the figure give the photo box; ratio is the photo's own width / height. */
        rules[file] =
          '.product-gallery .product-gallery-item:has(img[src*="/' + f + '"]) .lazy-image{background-color:' + col + ' !important;container-type:size}' +
          '.product-gallery img[src*="/' + f + '"]{--bgb-hw:min(50cqw,50cqh*' + ratio + ');--bgb-hh:min(50cqh,50cqw/' + ratio + ');' +
          '-webkit-mask-image:linear-gradient(to right,transparent calc(50% - var(--bgb-hw)),#000 calc(50% - var(--bgb-hw) + min(8px,50% - var(--bgb-hw))),#000 calc(50% + var(--bgb-hw) - min(8px,50% - var(--bgb-hw))),transparent calc(50% + var(--bgb-hw))),linear-gradient(to bottom,transparent calc(50% - var(--bgb-hh)),#000 calc(50% - var(--bgb-hh) + min(8px,50% - var(--bgb-hh))),#000 calc(50% + var(--bgb-hh) - min(8px,50% - var(--bgb-hh))),transparent calc(50% + var(--bgb-hh)));' +
          'mask-image:linear-gradient(to right,transparent calc(50% - var(--bgb-hw)),#000 calc(50% - var(--bgb-hw) + min(8px,50% - var(--bgb-hw))),#000 calc(50% + var(--bgb-hw) - min(8px,50% - var(--bgb-hw))),transparent calc(50% + var(--bgb-hw))),linear-gradient(to bottom,transparent calc(50% - var(--bgb-hh)),#000 calc(50% - var(--bgb-hh) + min(8px,50% - var(--bgb-hh))),#000 calc(50% + var(--bgb-hh) - min(8px,50% - var(--bgb-hh))),transparent calc(50% + var(--bgb-hh)));' +
          '-webkit-mask-composite:source-in;mask-composite:intersect}';
        var out = '';
        for (var k in rules) out += rules[k] + '\n';
        sheet().textContent = out;
      } catch (e) {
        delete done[file]; /* an unreadable early copy: try again on a later pass */
      }
    };
    probe.onerror = function () { delete done[file]; };
    probe.src = small(src);
  }
  function run() {
    var imgs = document.querySelectorAll('.product-gallery .product-gallery-item img');
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || imgs[i].currentSrc || '';
      var file = fileOf(src);
      if (file && !done[file]) sample(src.indexOf('//') === 0 ? location.protocol + src : src, file);
    }
  }
  /* the theme keeps re-rendering the gallery for a few seconds after load and on colour changes,
     so rather than chase elements, look again on a short timer, then on each colour change */
  var ticks = 0;
  var timer = setInterval(function () { run(); if (++ticks > 12) clearInterval(timer); }, 700);
  run();
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-variant__item--color')) {
      setTimeout(run, 300); setTimeout(run, 1200);
    }
  });
})();
